var locale = new Array();

if (web.lang == 'cs') {
	locale['newWindow'] = 'odkaz bude otevřen v novém okně';
	locale['externalLink'] = 'externí odkaz';
	locale['showPhotos'] = 'Zobrazit všechny fotografie';
	locale['hidePhotos'] = 'Skrýt fotografie';
}
if (web.lang == 'en') {
	locale['newWindow'] = 'link will be opened in a new window';
	locale['externalLink'] = 'external link';
}
if (web.lang == 'de') {
	locale['newWindow'] = 'Der Link wird in einem neuen Fenster geöffnet.';
	locale['externalLink'] = 'externer Link';
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/localization/locale.js